module.exports = __webpack_public_path__ + "img/Middle-Vertical-Rectangular-Attachment-38.4e3a7920.png";